import ReactGA from 'react-ga'

export const trackEvent = (event: ReactGA.EventArgs) => ReactGA.event(event)
